import { render } from "./FootballEventHeader.vue?vue&type=template&id=751ad8fc&scoped=true"
import script from "./FootballEventHeader.vue?vue&type=script&lang=js"
export * from "./FootballEventHeader.vue?vue&type=script&lang=js"

import "./FootballEventHeader.vue?vue&type=style&index=0&id=751ad8fc&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-751ad8fc"]])

export default __exports__